import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Download from '../views/Download.vue'
import Article from '../views/Article.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    // type:video视频  
    path: '/article/:type/:id',
    name: 'Article',
    component: Article
  }, 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
